import React, { useState } from "react";
import { useTranslation } from "i18n";

interface Props {
  text: string;
  limit?: number;
  textClassName?: string;
}

const rootClassName = "min-w-0 max-w-full [&_p]:min-w-0";

const ExpandableText = ({ text, limit = 1000, textClassName }: Props) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);

  if (text.length <= limit) {
    return (
      <div className={rootClassName}>
        <p className={textClassName}>{text}</p>
      </div>
    );
  }

  const displayText = isExpanded ? text : `${text.substring(0, limit)}...`;

  return (
    <div className={rootClassName}>
      <p className={textClassName}>
        {displayText}
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="ml-1 text-s font-bold text-color-brand-one hover:underline dark:text-color-accent-one"
        >
          {isExpanded
            ? t("common:button.label.less")
            : t("common:button.label.more.lower")}
        </button>
      </p>
    </div>
  );
};

export default ExpandableText;
